// extracted by mini-css-extract-plugin
export default {"clinicHours":"clinicHours_clinicHours__cplCJ","selected":"clinicHours_selected__-jZDp"};